import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { CircleAlert } from "lucide-react";
function PizzaGalleryConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="space-y-4">
            <Skeleton className="h-[300px] w-full rounded-lg" />
            <Skeleton className="h-6 w-3/4 mx-auto" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <CircleAlert className="h-10 w-10 text-destructive mb-4" />
        <p className="text-muted-foreground mb-4">
          Es gab ein Problem beim Laden der Galerie.
        </p>
        <Button onClick={refetch} variant="outline">
          Erneut versuchen
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground text-lg">
          Derzeit sind keine Bilder in der Galerie verfügbar.
        </p>
      </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="group block h-full" data-index={i}>
          <Card className="h-full overflow-hidden border-none bg-transparent shadow-none transition-colors">
            <div className="relative overflow-hidden rounded-lg shadow-soft group-hover:shadow-medium transition-all duration-500">
              <AspectRatio ratio={3 / 4}>
                <img src={post.customFields?.image || post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1513498/img/pizza_gallery_placeholder.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 ease-[var(--ease-out-back)] group-hover:scale-105" />
              </AspectRatio>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            </div>
            
            <CardContent className="pt-5 px-2 text-center">
              <h3 className="font-display text-xl font-medium text-foreground group-hover:text-primary transition-colors duration-300">
                {post.title}
              </h3>
              {post.customFields?.photographer && <p className="mt-1 text-sm text-muted-foreground italic font-serif">
                  Foto: {post.customFields.photographer}
                </p>}
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function PizzaGallery() {
  const wp_query_params = {
    per_page: 12,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}